import { useUserEventLogger } from '@repo/tracking-service';
import { ReactNode } from 'react';

import IntersectionObserverWrapper from '@/components/common/IntersectionObserverWrapper';
import { useSectionScrollModel } from '@/components/common/context/SectionScrollModelProvider';

export const ScrollEventWrapper = ({
  sectionId,
  onThresholdPass,
  sendInterSectionState,
  threshold,
  children
}: {
  sectionId: string;
  onThresholdPass?: () => void;
  sendInterSectionState?: (state: boolean) => void;
  threshold?: number;
  children: ReactNode;
}) => {
  const { pageName, sendScrollEvent } = useUserEventLogger();
  const { currentSectionId, setCurrentSectionId, scrollDirection, eventAttribute } = useSectionScrollModel();

  const scrollAction = () => {
    onThresholdPass?.();
    sendScrollEvent(pageName, Object.assign({ section: sectionId }, eventAttribute));
  };

  const alwaysScrollAction = () => {
    if ((scrollDirection === 'down' && currentSectionId <= sectionId) || (scrollDirection === 'up' && currentSectionId >= sectionId)) {
      setCurrentSectionId(sectionId);
    }
  };

  return (
    <IntersectionObserverWrapper
      id={`section-${sectionId}`}
      onThresholdPass={scrollAction}
      onAlwaysThresholdPass={alwaysScrollAction}
      sendInterSectionState={sendInterSectionState}
      threshold={threshold ?? 0.5}
      once={true}
    >
      {children}
    </IntersectionObserverWrapper>
  );
};
